import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { getMerchantTerminalContractQueryKey } from "Api/Queries/Merchants/useGetMerchantTerminalContractQuery";
import { getMerchantTerminalContractsQueryKey } from "Api/Queries/Merchants/useGetMerchantTerminalContractsQuery";
import { deleteMerchantsPublicIDTerminalContractsTerminalContractPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  terminalContractPublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteMerchantTerminalContractMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, terminalContractPublicID }: Parameters) =>
        deleteMerchantsPublicIDTerminalContractsTerminalContractPublicID(
          merchantPublicID,
          terminalContractPublicID,
        ),
    ),
    onSuccess: (
      _,
      { merchantPublicID, terminalContractPublicID }: Parameters,
    ) => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(merchantPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: getMerchantTerminalContractsQueryKey(merchantPublicID),
      });
      queryClient.removeQueries({
        queryKey: getMerchantTerminalContractQueryKey(
          merchantPublicID,
          terminalContractPublicID,
        ),
      });
      onSuccess?.();
    },
    onError,
  });
};
